"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dotScaleExitConfig = exports.dotScaleEnterConfig = exports.dotOpacityExitConfig = exports.dotOpacityEnterConfig = void 0;
var _tokens = require("./tokens");
/**
 * Motion specs
 * @link https://coda.io/d/Motion-Foundations_d5KlLHcBPlL/CDS-Dots_suq2C#_luRZr
 */
const dotOpacityEnterConfig = (0, _tokens.createMotionConfig)('fadeIn', 'moderate1');
exports.dotOpacityEnterConfig = dotOpacityEnterConfig;
const dotScaleEnterConfig = (0, _tokens.createMotionConfig)('scaleUpS', 'moderate1');
exports.dotScaleEnterConfig = dotScaleEnterConfig;
const dotOpacityExitConfig = (0, _tokens.createMotionConfig)('fadeOut', 'moderate1');
exports.dotOpacityExitConfig = dotOpacityExitConfig;
const dotScaleExitConfig = (0, _tokens.createMotionConfig)('scaleDownS', 'moderate1');
exports.dotScaleExitConfig = dotScaleExitConfig;